module.exports = __webpack_public_path__ + "img/toon_2.d1514a80.png";